import { WHOLESALE_PRODUCT_IDS } from '../../../variables/products';

export const checkIsDiscountBadgeShown = (items = []) => (
  !(items.some((item) => WHOLESALE_PRODUCT_IDS.includes(item.product_id)))
);
